const Publi = () => {
    return (
        <div className='w-10/12 mb-8 font-semibold'>
            <h1 name='topo' className='flex pb-5 text-5xl font-extrabold pt-24'>Bom Rolê</h1>
            <p>A maior quantidade de Rolês pagos e gratuitos em São Paulo você encontra aqui.</p>
        </div>
    )
}

export default Publi